import { Routes } from '@angular/router';
import { DashboardComponent } from './dashboard/dashboard.component';
import { DashboardComparisonComponent } from './dashboard-comparison/dashboard-comparison.component';
import { SelfServiceVisualizationComponent } from '@shared-lib/self-service-visualization/self-service-visualization.component';
import { DvmLayoutBuilderComponent } from '@shared-lib/self-service-visualization/dvm-layout-builder/dvm-layout-builder.component';

import { AuthGuard } from './shared/guards/auth.guard';
// Using custom override - bar chart with pink/red color
// import { BarChartComponent } from '@custom';
import { ChatComponent } from '@shared-lib/global-components/chat/chat.component';
import { DvmPublishedDashboardComponent } from '@shared-lib/self-service-visualization/dvm-published-dashboard/dvm-published-dashboard.component';
import { DvmLandingPageBuilderComponent } from '@shared-lib/self-service-visualization/dvm-landing-page/dvm-landing-page-builder.component';
import { environment } from '../environments/environment';

const LANDING_ROUTE =
  String((environment as Record<string, unknown>)['LANDING_ROUTE'] ?? '')
    .trim()
    // Leading slash would make Angular treat this as an absolute redirect from
    // the router root — harmless here, but stripped so both forms behave the same.
    .replace(/^\/+/, '')
  || 'generate-visualization';

export const routes: Routes = [
  {
    path: '',
    redirectTo: LANDING_ROUTE,
    pathMatch: 'full',
  },

  {
    path: 'dashboard',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'dashboard-config.json' },
  },
  {
    path: 'generated/:dashboardSlug',
    component: DashboardComponent,
    canActivate: [AuthGuard],
  },
   {
    path: 'revenue',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'PAT/revenue.json' },
  },
   {
    path: 'screen-1',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'PAT/screen-1.json' },
  },
  {
    path: 'all-charts',
    redirectTo: 'all-chart-1',
    pathMatch: 'full',
  },
  {
    path: 'all-chart-1',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'all-chart-1.json' },
  },
  {
    path: 'customer_view',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'PAT/customer_view.json' },
  },
   {
    path: 'customer_view_2',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'PAT/customer_view_2.json' },
  },
   {
    path: 'table',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'PAT/table.json' },
  },
  {
    path: 'stack-bar',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'PAT/stack-bar.json' },
  },



  {
    path: 'all-chart-2',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'all-chart-2.json' },
  },
  {
    path: 'all-chart-3',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'all-chart-3.json' },
  },
  {
    path: 'test',
    component: DashboardComparisonComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'tabbed-dashboard',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'tabbed-demo.json' },
  },
  {
    path: 'generate-visualization',
    component: SelfServiceVisualizationComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'dvm-layout-builder',
    component: DvmLayoutBuilderComponent,
    canActivate: [AuthGuard],
  },

  // Landing Page template builder — landing pages publish as regular
  // dashboard_layouts rows and are then SERVED by /dvm-published/:slug, so
  // that slug is also what LANDING_ROUTE should point at (environment files).
  {
    path: 'dvm-landing-builder',
    component: DvmLandingPageBuilderComponent,
    canActivate: [AuthGuard],
  },

   {
    path: 'all-charts-dark-theme',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'all-charts-theme.json' },
  },

  {
    path: 'financial-metrics',
    component: DashboardComponent,
    data: { configFile: 'financial-metrics-poc.json' },
    canActivate: [AuthGuard],
  },
   {
    path: 'detailed_view',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'psbu_sales_overview.json' },
  },
   {
    path: 'europe-impact-report',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'europe-Impact-report.json' },
  },
  {
    path: 'dvm-charts_dark-theme',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'detailed_view-dark-theme.json' },
  },

  {
    path: 'dvm-charts',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'detailed_view-light-theme.json' },
  },

  {
    path: 'chat',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'chat-config.json' },
  },
  {
    path: 'login',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'PAT/login_page.json' },
  },
   {
    path: 'oem_positioning',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'PAT/oem_positioning.json' },
  },
  {
    path: 'confer',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'PAT/confer.json' },
  },
  {
    path: 'configuration',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'PAT/configuration.json' },
  },
   {
    path: 'scatter',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'PAT/scatter.json' },
  },
{
    path: 'sales-overview',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configFile: 'generated/sales-overview.json' },
  },


  {
    path: 'dvm-published/:slug',
    component: DvmPublishedDashboardComponent,
    canActivate: [AuthGuard],
  },

  // Dynamic dashboards fetched from /dashboard_layouts/dynamic_filter and cached
  // in localStorage by the sidenav. Declared before :slug so it wins.
  {
    path: 'dynamic-dashboard/:slug',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configSource: 'dynamic-api' },
  },

  // Published self-service dashboards are navigated to by name-slug (e.g.
  // /my-sales-dashboard). This MUST stay last among the matchable routes — a
  // single-segment :slug greedily matches any path, so every hardcoded route
  // above has to be declared first to win. The handler in DashboardComponent
  // reads the slug from localStorage via configSource: 'self-service-local'.
  {
    path: ':slug',
    component: DashboardComponent,
    canActivate: [AuthGuard],
    data: { configSource: 'self-service-local' },
  }
];
